import { render, staticRenderFns } from "./ProposalProductsView.vue?vue&type=template&id=4414833e&scoped=true&"
import script from "./ProposalProductsView.vue?vue&type=script&lang=js&"
export * from "./ProposalProductsView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalProductsView.vue?vue&type=style&index=0&id=4414833e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414833e",
  null
  
)

export default component.exports